import React from 'react';

const SvgComponent = props => (
  <svg width={20} height={20} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11 14.913c1.304 0 4.348-1.74 4.348-4.348 1.304 0 1.304-2.608 0-2.608l-.435-2.174c-3.478 0-3.478-1.305-3.913-1.74-.435.435-.435 1.74-3.913 1.74l-.435 2.174c-1.304 0-1.304 2.608 0 2.608 0 2.609 3.044 4.348 4.348 4.348Z"
      stroke="#224251"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m16.21 8.609.443-3.261S17.088 1 11 1 5.349 5.348 5.349 5.348l.443 3.26M8.791 14.052l-5.53 1.513A3.482 3.482 0 0 0 1 18.826V21h20v-2.174a3.478 3.478 0 0 0-2.26-3.26l-5.514-1.523"
      stroke="#224251"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.39 8.826c0-.478.392-.435.87-.435s.87-.043.87.435M11.87 8.826c0-.478.39-.435.869-.435.478 0 .87-.043.87.435"
      stroke="#224251"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 17.087 8.39 21h5.218l-2.609-3.913ZM9.695 14.478v1.305c0 .721.583 1.304 1.305 1.304.721 0 1.304-.583 1.304-1.304v-1.305M15.783 18.391h3.044"
      stroke="#224251"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgComponent;
